import type { PeriodValue as LumenPeriodValue } from '@shinetools/lumen-react'
import { isSameDay } from 'date-fns'

import type { DateRange } from '../types/dateRange'

export const isMatchingDateRange = (value: LumenPeriodValue, dateRange: DateRange | undefined): boolean => {
  if (!dateRange || value.mode !== 'custom' || !value.start || !value.end) {
    return false
  }

  return isSameDay(value.start, dateRange.startDate) && isSameDay(value.end, dateRange.endDate)
}
